// extracted by mini-css-extract-plugin
export default {"duration":"mqZrV3Uuu3KjIhXc8C25"};